import React, { useState, useEffect } from 'react';
import qs from 'qs';
import { useLocation } from 'react-router-dom';
import { DateRangePicker } from 'react-date-range';
import { fr } from 'date-fns/locale';
import moment from 'moment';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button
} from '@material-ui/core';
import {
  customInputRanges,
  staticRangesCustom
} from '../../exportCommands/CommandsReport/datePickerCustom';

const PeriodicityButton = ({ onChange, initButtonLabelCustom = 'Date' }) => {
  const { search: locationSearch } = useLocation();

  const getUrlParams = () =>
    qs.parse(locationSearch, { ignoreQueryPrefix: true });

  const [buttonLabelCustom, setButtonLabelCustom] = useState(
    initButtonLabelCustom
  );

  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection'
  });
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    if (!getUrlParams().expectedDeliveryDateFrom) {
      return setButtonLabelCustom('Filtrer par date');
    }
    return setButtonLabelCustom(
      `${moment(selectionRange.startDate)
        .add(3, 'hours')
        .format('L')} -
        ${moment(selectionRange.endDate)
          .add(3, 'hours')
          .format('L')}`
    );
  }, [
    getUrlParams().expectedDeliveryDateFrom,
    getUrlParams().expectedDeliveryDateTo
  ]);
  /**
   * Function permettant de modifier le créneau d'export
   * @param  {object} date object avec les date de debut et de fin d'export
   */
  const handleDateSelection = date => {
    setSelectionRange(date.selection);
  };

  const handleChangeCustomRange = () => {
    onChange({
      name: 'CUSTOM_RANGE',
      label: 'Personalisé',
      dateFrom: moment(selectionRange.startDate)
        .add(3, 'hours')
        .toISOString(),
      dateTo: moment(selectionRange.endDate)
        .add(3, 'hours')
        .toISOString()
    });
    setOpenDialog(false);
  };

  const handleChange = () => {
    setOpenDialog(true);
  };
  return (
    <div>
      <Button
        variant="outlined"
        style={{ width: 200, textTransform: 'none' }}
        onClick={handleChange}
      >
        {buttonLabelCustom}
      </Button>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogContent>
          <DateRangePicker
            moveRangeOnFirstSelection={false}
            onChange={handleDateSelection}
            ranges={[selectionRange]}
            locale={fr}
            months={2}
            minDate={new Date('January 01, 2016')}
            direction="horizontal"
            staticRanges={staticRangesCustom}
            inputRanges={customInputRanges}
          />
          <DialogActions>
            <Button
              onClick={() => setOpenDialog(false)}
              color="secondary"
              variant="contained"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              onClick={handleChangeCustomRange}
            >
              Valider
            </Button>
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
};

PeriodicityButton.propTypes = {
  onChange: PropTypes.func,
  initButtonLabelCustom: PropTypes.string
};

export default PeriodicityButton;
